import { Button, Image, Modal } from "antd";
import React from "react";

const PriceModal = ({ open, setIsOpen, record }) => {
  return (
    <>
      <Modal
        title={"Price"}
        footer={null}
        className="shadow-normal"
        width={300}
        maskClosable={false}
        open={open}
        onCancel={() => setIsOpen(false)}
      >
        <div className="mt-10">
          <img
            src={record.icon}
            className="w-28 m-auto animate-bounce  h-28"
            alt="success"
          />
          <p className="text-center font-semibold text-lg">
            <span className="capitalize">{record.label}</span>
          </p>
          <p className="text-center font-semibold text-lg">
            <span className="capitalize ">{record.price}</span>
          </p>
        </div>
        <Button
          onClick={() => setIsOpen(false)}
          className="w-full mt-28 bg-primary hover:bg-primaryhover text-bswhite rounded-sm border-none "
        >
          Go Back
        </Button>
      </Modal>
    </>
  );
};

export default PriceModal;
